import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { AccountApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { LoopBackAuth } from '../../sdk/services/core/auth.service';


/*
This custom field is used to select global dataelements for an app.
*/

@Component({
    selector: 'formly-user-selector',
    template: `
   <ng-select *ngIf="items.length > 0"   
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="false"
               [disabled]="to.disabled"
              placeholder=""
              [allowClear]="!to.required" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
    providers: [AccountApi]
})
export class UserSelect extends FieldType implements OnInit, OnDestroy {
    _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
    items: any = [];
    selectedvalues: any = [];
    currentuser;
    constructor(private _AccountApi: AccountApi, private _LoopBackAuth: LoopBackAuth) {
        super();
    }

    ngOnInit() {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        //1) Load the drop down values    
        this._loopbackfilter.where = { 'appId': this.currentuser.appId };
        //Hack - Get the app id from the model itself.
        //Get the dataelements for the App
        this._AccountApi.find(this._loopbackfilter).subscribe((users) => {
            if (users) {

                for (var i = 0; i < users.length; i++) {
                    if (this.model.id !== users[i]["id"]) {
                        this.items.push({ id: users[i]["id"], text: users[i]["email"] })
                    }

                    if (this.model[this.key] && this.model[this.key].indexOf(users[i]["id"]) > -1) {
                        this.selectedvalues = [{ id: users[i]["id"], text: users[i]["email"] }];
                    }
                }
                //Sort the values
                this.items = _.sortBy(this.items, 'text');
            }
        });

    }

    ngOnDestroy() {
        this.selectedvalues = "";
    }

    private value: any = {};


    public selected(value: any): void {
        this.model[this.key] = value.id;
    }

    public removed(value: any): void {

        /*
       Remove the removed value to the model
       */
        if (this.model[this.key] && this.model[this.key].length) {
            this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
        }
    }

    public typed(value: any): void {

    }

    public refreshValue(value: any): void {
        this.value = value;
    }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectuser.ts